"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var ConfirmationModal = function ConfirmationModal(props) {
  return (0, _preact.h)(_reactModal.default, {
    className: "confirmation-modal",
    isOpen: props.enableModal,
    onClose: props.onClose
  }, props.showError ? (0, _preact.h)("div", {
    className: "alert alert-danger"
  }, props.errorMessage ? props.errorMessage : 'Something went wrong, please try it again later.') : null, (0, _preact.h)("h3", {
    className: "confirmation-modal_title"
  }, props.title), (0, _preact.h)("div", {
    className: "confirmation-modal_message"
  }, props.message), (0, _preact.h)("div", {
    className: "confirmation-modal_buttons"
  }, props.buttons.map(function (button) {
    return (0, _preact.h)("button", {
      onClick: button.callback,
      className: "".concat(button.class, " ").concat(props.isLoading && button.showLoading ? 'is--loading' : '')
    }, button.showLoading ? (0, _preact.h)("div", null, (0, _preact.h)("div", {
      className: "btn--loader"
    }), (0, _preact.h)("span", {
      className: "btn__hide-when-loading"
    }, button.text)) : button.text);
  })));
};

var _default = ConfirmationModal;
exports.default = _default;